import { render, staticRenderFns } from "./widget_code.vue?vue&type=template&id=055dc6e8&scoped=true&lang=pug&"
import script from "./widget_code.vue?vue&type=script&lang=js&"
export * from "./widget_code.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055dc6e8",
  null
  
)

export default component.exports